// Copyright (c) Docugami, Inc. All rights reserved.

import styled from "styled-components";
import { TagList } from "./TagsList";

const TagsRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 7px;
    overflow-x: hidden;
    overflow-y: auto;
`

export interface TagsCollection {
    tags: string[];
    label: string;
    onSelected: (tag: string) => void;
}

export interface TagsViewerProps {
    tags: TagsCollection[];
}

export const TagsViewer = (props: TagsViewerProps): JSX.Element => {
    return (
        <TagsRoot>
            {
                props.tags.filter(x => x.tags.length > 0).map(c => {
                    return <TagList key={c.label} tags={c.tags} label={c.label} onSelected={c.onSelected} />;
                })
            }
        </TagsRoot>
    )
}
